// eslint-disable-next-line import/no-anonymous-default-export
export default {
  type: 'showInMap',
  options: {
    text: 'View in',
  },
};
